//Subcomponent shared by step view and status page.

import React, { useEffect, useState } from 'react'
import { useTranslation } from 'i18n'

import Check from 'images/inline/receipt/check.svg'
import Pending from 'images/inline/receipt/pending.svg'
import X from 'images/inline/receipt/x.svg'
import './Status.scss'
//submitted, approved, rejected

const ReceiptStatus = ({ status = 'submitted', onStatusRetrieved }) => {
  const { t } = useTranslation('receipt')
  const [statusCopy, setStatusCopy] = useState(null)
  const assignStatusCopy = status => {
    if (status === 'APPROVED') {
      return {
        dialogueTitle: t('status.approved.title'),
        icon: <Check />,
        dialogueText: t('status.approved.description'),
      }
    } else if (status === 'REJECTED') {
      return {
        dialogueTitle: t('status.rejected.title'),
        icon: <X />,
        dialogueText: t('status.rejected.description'),
      }
    } else {
      return {
        dialogueTitle: t('status.submitted.title'),
        icon: <Pending />,
        dialogueText: t('status.submitted.description'),
      }
    }
  }

  useEffect(() => {
    setStatusCopy(assignStatusCopy(status))
    onStatusRetrieved && onStatusRetrieved(status)
  }, [status])

  return (
    <div className="receipt-status">
      {statusCopy && (
        <div className={`receipt-status-dialogue`}>
          <div className={`receipt-status-icon`}>
            <div className="receipt-status-icon-element">{statusCopy.icon}</div>
          </div>
          <h3 className={`receipt-status-dialogue-desc`}>
            {t('statusLabel', { status: statusCopy.dialogueTitle })}
          </h3>
        </div>
      )}
    </div>
  )
}
export default ReceiptStatus
